/*
 * <afaq-copy data-copy="…"> — one-tap copy for an IBAN or account number,
 * used by sections/afaq-bank-accounts.liquid.
 *
 * A custom element so it wires itself when the theme editor re-renders the
 * section (innerHTML never runs injected scripts). navigator.clipboard needs
 * a secure context; the textarea fallback covers older in-app browsers, which
 * is where many customers open a link sent over WhatsApp.
 */
class AfaqCopy extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.status = this.querySelector('[role="status"]');
    if (!this.button) return;
    this.button.addEventListener('click', () => this.copy());
  }

  async copy() {
    const value = this.dataset.copy || '';
    let ok = false;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
        ok = true;
      }
    } catch (error) {
      ok = false;
    }

    if (!ok) {
      const area = document.createElement('textarea');
      area.value = value;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      try {
        ok = document.execCommand('copy');
      } catch (error) {
        ok = false;
      }
      area.remove();
    }

    this.flash(ok ? 'تم النسخ' : 'تعذّر النسخ');
  }

  flash(message) {
    if (!this.status) return;
    this.status.textContent = message;
    this.toggleAttribute('data-copied', true);
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.status.textContent = '';
      this.removeAttribute('data-copied');
    }, 2000);
  }
}

if (!customElements.get('afaq-copy')) customElements.define('afaq-copy', AfaqCopy);
